import { Component, ViewChild, ElementRef, AfterViewInit, Input, OnInit } from '@angular/core';
import { FacilitiesService } from '../../../../core/facilities/facilities.service';
import { ChartOptionsFactory } from '../../../chart-options-factory';
import Highcharts from 'highcharts';
import * as api from "../../../../api";
import { AbstractAggregateChartsComponent } from "../../abstract-aggregate-charts.component";
import { LoadingError } from "../../../../core/error-catching.service";
import { takeUntil, catchError } from 'rxjs/operators';
import { ChartFilterService } from '../../../../core';
import { ApiRequestDto } from '../../../../api';

/**
 * Show donut chart for residents on controlled meds
 */
@Component({
    selector: 'my-controlled-med-summary-donut-charts',
    template: `<div #donutChart></div>`,
    inputs: AbstractAggregateChartsComponent.INPUTS

})
export class ControlledMedSummaryDonutComponent extends AbstractAggregateChartsComponent implements AfterViewInit, OnInit {

    ////// Donut Chart
    @ViewChild('donutChart', {static: false}) donutChartDivRef: ElementRef;
    private donutChart: Highcharts.Chart;

    @Input()
    summary: boolean = true;

    @Input()
    fixedLegend: boolean;

    /** Construct */
    constructor(
        private controlledMedOrdersSummaryService: api.ControlledMedOrdersService,
        private chartFilterService: ChartFilterService,
        facilitiesSvc: FacilitiesService,
    ) {
        super(facilitiesSvc);
    }

    ngOnInit() {
        this.chartFilterService.gabapentinSubject
            .pipe(takeUntil(this.destroy$))
            .subscribe((included) => {
                if (this.isReadyToUpdate()) {
                    this.updateIfReady();
                }
            });
    }

    /**
     * Setup the charts.
     * @override
     */
    buildAllCharts(): void {
        this.chartTitle = '% of Residents on Controlled Medications';
        let donutChartOptions = ChartOptionsFactory.buildDonutType(this.chartTitle);

        if(this.fixedLegend){
            donutChartOptions.tooltip = {
                headerFormat: "",
                pointFormat: "<b>{point.y}</b>"
            };
        }


        this.donutChart = super.createChart(this.donutChartDivRef, donutChartOptions);
    }

    /**
     * Fetch all data and update display
     * @override
     */
    fetchAndPopulate(): void {
        const requestParams: ApiRequestDto = {
            StartDate: this.dateRange.startJsDateUTC,
            EndDate: this.dateRange.endJsDateUTC,
            OrgList: this.facilitiesSvc.selectedAsOrgList
        };
        const includeGabapentin = this.chartFilterService.getGabapentinFilter();
        this.controlledMedOrdersSummaryService.controlledMedOrdersGetControlledMedPercentage(requestParams, includeGabapentin)
            .pipe(takeUntil(this.stop$),
                catchError((error)=>{
                    throw new LoadingError(this.chartTitle);
                }))
            .subscribe((residentCount: api.MedicationSummaryCountResult) => {
                if(this.fixedLegend){
                    ChartOptionsFactory.addHiddenLegendItems(residentCount, 6);
                }

                this.populateMedSummaryCountDonut(this.donutChart, residentCount, false);
                ChartOptionsFactory.disableHiddenItemsHoverInLegend(this.donutChart);
            });
    }
}
